import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// libraries
import $ from 'jquery';

import GenericFormPopUp from '../generic_components/GenericFormPopUp';

import * as CONSTANTS from '../constants';
import * as CONFIG from '../config';
import * as UTILS from '../utils/utilFunctions';
import TEXT_GENERAL from '../text';

import TEXT from './staticContent/text';
import { staticResources } from './staticContent/ProjectDetailsUpdatePopUpDropDowns';

// custom: for key value dropDowns
// TODO refactor to parent component
function prepareEmployeesKeyValuePairs(employees, onlyAdvisors = false) {
  const mappedDropDownEntries = [];
  if (employees && employees.length > 0) {
    if (CONSTANTS.isLienert && onlyAdvisors) {
      employees.forEach(employee => {
        if (employee.lastname && employee.isAdvisor) {
          const value = employee.id;
          const label = `${employee.firstname || ''} ${employee.lastname}`;
          const mappedEmployee = { value, label };
          mappedDropDownEntries.push(mappedEmployee);
        }
      });
    } else {
      employees.forEach(employee => {
        if (employee.lastname) {
          const value = employee.id;
          const label = `${employee.firstname || ''} ${employee.lastname}`;
          const mappedEmployee = { value, label };
          mappedDropDownEntries.push(mappedEmployee);
        }
      });
    }
  }
  return mappedDropDownEntries;
}

class ProjectDetailsUpdatePopUpContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.form = this.generateFormFields();
    // error handling required for API calls
    this.errorHandling = UTILS.errorHandling.bind(this);
  }

  updateProjectDetailsAPICall = updatedData => {
    const tokenFromLocalStorage = window.sessionStorage.getItem('token');
    // custom
    // TODO refactor parent component
    const url = CONSTANTS.updateProjectURL;

    const payload = {
      projectId: this.props.projectId,
      updateData: updatedData
    };
    if (Object.keys(updatedData).length > 0) {
      console.log(`API ${url} request`, payload);
      $.ajax({
        url,
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        headers: { 'x-auth': tokenFromLocalStorage },
        data: JSON.stringify(payload),
        timeout: CONFIG.ajaxTimeout
      })
        .done((responseBody, status) => {
          console.log(`API /${url} response`, responseBody, status);
          this.props.handleSnackbarOpen(
            TEXT_GENERAL.snackBarTexts.updateSuccess
          );
          this.props.refreshProject();
          // this.props.liftUpStateToProjectArchive(
          //   'selectedProject',
          //   updatedData
          // );
          this.props.handleClose();
        })
        .fail(err => {
          this.errorHandling(err, url, null, [400]);
          if (err.status === 400) {
            this.props.handleSnackbarOpen(
              'Die Auftragsnummer ist bereits vergeben!'
            );
          }
        });
    } else {
      this.props.handleSnackbarOpen(TEXT_GENERAL.snackBarTexts.noUpdate);
    }
  };

  generateFormFields() {
    const forms = {
      formFields: {
        jobTitle1: {
          value: this.props.isUpdate ? this.props.data.jobTitle1 || '' : '',
          // validator: 'isText',
          required: true,
          customClass: 'col-12 mb-2',
          label: TEXT.projectDetailsUpdatePopUp.labels.jobTitle1
          // required: false
        },
        projectNumber: {
          value: this.props.isUpdate ? this.props.data.projectNumber || '' : '',
          // validator: 'isText',
          required: true,
          customClass: 'col-12 mb-2',
          label: TEXT.projectDetailsUpdatePopUp.labels.projectNumber,
          validator: 'isText'
          // required: false
        },
        status: {
          value: this.props.isUpdate ? this.props.data.status : '',
          type: 'dropDown',
          content: staticResources.dropDowns.status.content,
          required: true,
          label: TEXT.projectDetailsUpdatePopUp.labels.status
        },
        statusDetails: {
          value: this.props.isUpdate ? this.props.data.statusDetails : '',
          type: 'dropDown',
          content: staticResources.dropDowns.statusDetails.content,
          required: false,
          label: TEXT.projectDetailsUpdatePopUp.labels.statusDetails
        },
        serviceType: {
          value: this.props.isUpdate ? this.props.data.serviceType : '',
          type: 'dropDown',
          content: staticResources.dropDowns.serviceType.content,
          required: true,
          label: TEXT.projectDetailsUpdatePopUp.labels.serviceType
        },
        consultingUser: {
          value:
            this.props.isUpdate && this.props.data.consultingUser
              ? this.props.data.consultingUser.id
              : '',
          type: 'dropDown',
          content: prepareEmployeesKeyValuePairs(this.props.employees, true),
          required: true,
          label: TEXT.projectDetailsUpdatePopUp.labels.consultingUser
        },
        editingUser: {
          value:
            this.props.isUpdate && this.props.data.editingUser
              ? this.props.data.editingUser.id
              : '',
          type: 'dropDown',
          content: prepareEmployeesKeyValuePairs(this.props.employees, false),
          required: true,
          label: TEXT.projectDetailsUpdatePopUp.labels.editingUser
        },
        // jobTitle2: {
        //   value: this.props.isUpdate ? this.props.data.jobTitle2 || '' : '',
        //   // validator: 'isText',
        //   customClass: 'col-12 mb-1 mt-1',
        //   label: TEXT.projectDetailsUpdatePopUp.labels.jobTitle2
        // },
        numberOfPositions: {
          value: this.props.isUpdate
            ? this.props.data.numberOfPositions || ''
            : '',
          validator: 'isNumerical',
          isRequired: true,
          label: TEXT.projectDetailsUpdatePopUp.labels.numberOfPositions
        },

        comment: {
          value: this.props.isUpdate ? this.props.data.comment || '' : '',
          // validator: 'isText',
          required: false,
          customClass: 'col-12 mb-1 mt-1',
          additionalProps: { multiline: true },
          label: TEXT.projectDetailsUpdatePopUp.labels.comment
        }
      }
    };
    if (CONSTANTS.isLienert) {
      forms.formFields.confidential = {
        value: this.props.isUpdate ? this.props.data.confidential || '' : '',
        // validator: 'isText',
        label: TEXT.projectDetailsUpdatePopUp.labels.confidential
      };
      forms.formFields.partTime = {
        value: this.props.isUpdate ? this.props.data.partTime || '' : '',
        // validator: 'isText',
        label: TEXT.projectDetailsUpdatePopUp.labels.partTime,
        type: 'dropDown',
        content: ['50%', '80%', '100%']
      };
      forms.formFields.castingType = {
        value: this.props.isUpdate ? this.props.data.castingType || '' : '',
        // validator: 'isText',
        label: TEXT.projectDetailsUpdatePopUp.labels.castingType
      };
    } else {
      forms.formFields.supervisor = {
        value: this.props.isUpdate ? this.props.data.supervisor || '' : '',
        // validator: 'isText',
        label: TEXT.projectDetailsUpdatePopUp.labels.supervisor
      };
      forms.formFields.salary = {
        value: this.props.isUpdate ? this.props.data.salary || '' : '',
        // validator: 'isText',
        label: TEXT.projectDetailsUpdatePopUp.labels.salary
      };
    }
    // add label text to formFields state
    Object.keys(forms.formFields).forEach(key => {
      forms.formFields[key].label =
        TEXT.projectDetailsUpdatePopUp.labels[key] || '';
    });

    return forms;
  }

  render() {
    this.form = this.generateFormFields();
    return (
      <GenericFormPopUp
        open={this.props.open}
        headlineText={TEXT.projectDetailsUpdatePopUp.headline}
        key="hallo"
        genericFormProps={{
          formFields: this.form.formFields,
          isUpdate: true,
          handleSubmit: this.updateProjectDetailsAPICall,
          // initialData: this.props.data,
          handleClose: this.props.handleClose,

          buttonCancelText: TEXT.projectDetailsUpdatePopUp.buttons.cancel,
          buttonSaveText: TEXT.projectDetailsUpdatePopUp.buttons.save
        }}
      />
    );
  }
}
ProjectDetailsUpdatePopUpContainer.defaultProps = {
  isUpdate: false,
  data: {}
};

ProjectDetailsUpdatePopUpContainer.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  isUpdate: PropTypes.bool,
  // data
  projectId: PropTypes.string.isRequired,
  data: PropTypes.object,
  // snackBar
  handleSnackbarOpen: PropTypes.func.isRequired,
  // dropDown key values
  employees: PropTypes.array.isRequired,

  // custom: only required for subSchema update
  // dataSetId: PropTypes.string,
  refreshProject: PropTypes.func.isRequired
};

export default ProjectDetailsUpdatePopUpContainer;
